import { useState, useEffect } from 'react';

// 일렉트론 앱 환경인지 확인하는 hook
const useIsElectron = (): boolean => {
  return navigator.userAgent.includes('Electron');
};

export default useIsElectron;
